import { component } from 'picoapp'
import '@/lib/jquery-global.js';

export default component((node, ctx) => {

    

    if (node.querySelector('.js-megamenu-trigger')) {

        let trigger = node.querySelector('.js-megamenu-trigger');

        trigger.addEventListener('click', function(e) {

            e.preventDefault();
            jQuery(node.querySelector('.js-megamenu')).slideToggle();

            trigger.classList.toggle('open');

        })

    }

})
